module.exports = __webpack_public_path__ + "img/rium-logo.e41d639a.png";